import * as React from 'react';
import { capitalize } from 'lodash';

import TextBadge, { TextBadgeColor, TextBadgeTextColor } from 'components/TextBadge';

export type BadgeMap = {
  [k: string]: {
    textColor: TextBadgeTextColor;
    color: TextBadgeColor;
    textSize?: 'xsmall' | 'xxxxsmall';
    textWeight?: 'normal' | 'semibold';
  };
};

type Props = {
  content: string;
  color: TextBadgeColor;
  textColor: TextBadgeTextColor;
  textSize?: 'xsmall' | 'xxxxsmall';
  textWeight?: 'normal' | 'semibold';
};

function TextBadgeCell({ content, color, textColor, textSize, textWeight }: Props) {
  return (
    <TextBadge
      textSize={textSize || 'xxxxsmall'}
      textWeight={textWeight || 'normal'}
      textColor={textColor}
      color={color}>
      {capitalize(content)}
    </TextBadge>
  );
}

export function getTextBadgeCellGenerator<T>(
  fieldName: keyof T,
  badgeMap: BadgeMap,
  transformCallback?: (value: string) => string
) {
  return (data: T) => {
    const content = (data[fieldName] as unknown) as string;

    if (!content) {
      return <span />;
    }

    return (
      <TextBadgeCell
        content={transformCallback ? transformCallback(content) : content}
        textColor={badgeMap[content] ? badgeMap[content].textColor : 'whiteout'}
        color={badgeMap[content] ? badgeMap[content].color : 'graphite'}
        textSize={badgeMap[content] ? badgeMap[content].textSize : 'xxxxsmall'}
        textWeight={badgeMap[content] ? badgeMap[content].textWeight : 'normal'}
      />
    );
  };
}
